export type Photoable = {
  photos: Photo[];
}

export type Photo = {
  type: string | null;
  filename: string;
  mime: string;
  alt: string | null;
}


export function photoUrl(filename: string, size?: string, density?: number, webp: boolean = false) {
  let path = `/photos`;

  if (size) {
    path = `${path}/${size}`;
  }

  if (webp) {
    filename = filename.substring(0, filename.lastIndexOf('.')) + '.webp';
  }

  path = `${path}/${filename}`;

  if (density) {
    path = `${path} ${density}x`;
  }

  return path;
}


export function mediaQuery(min: number | string | null | undefined, max: number | string | null | undefined): string | undefined {
  if (!min && !max) {
    return undefined;
  } else if (min && max) {
    return `(min-width: ${min}px) and (max-width: ${max}px)`;
  } else if (min) {
    return `(min-width: ${min}px)`;
  }

  return `(max-width: ${max}px)`;
}

export function parseSize(raw?: string | null) {
  if (!raw) {
    return [];
  }

  return raw.split(',').map((entry) => {
    entry = entry.trim();

    let size: any = entry.match(/\d+x\d+/);
    let density: any = entry.match(/\s(\d+)x/);
    let min: any = entry.match(/min (\d+)/);
    let max: any = entry.match(/max (\d+)/);

    if (density) density = Number(density[1]);
    if (min) min = Number(min[1]);
    if (max) max = Number(max[1]);

    return { size, density, min, max };
  });
}

export function extractFromPhotoable(model: Photoable, type: string, multi?: boolean): Photo[] {
  if (multi) {
    return model.photos.filter((photo: Photo) => photo.type === type);
  }

  let photo = model.photos.find((photo: Photo) => photo.type === type);

  if (photo) {
    return [photo];
  }

  return [];
}

export function createPhotosFromFilename(filename: string): Photo[] {
  let ext = filename.substring(filename.lastIndexOf('.'));
  let mime = 'image/jpeg';
  let alt = '';

  switch (ext) {
    case 'png':
      mime = 'image/png';
      break;

    case 'gif':
      mime = 'image/gif';
      break;

    case 'webp':
      mime = 'image/webp';
      break;
  }

  return [
    { filename, mime, alt, type: null },
  ];
}
